import assetsConfig from '@meitu/wasm-lib/assetsConfig.json';

export const AR_RES_ID = 'ar_res';
export const AR_RES_PATH = assetsConfig.text_ar_res;
export const AR_PUBLIC_PARAMS = assetsConfig.text_hbpArPublicParams;
export const SHAPE_TEXT_RES_ID = 'textpatheffect';
export const SHAPE_TEXT_PATH = assetsConfig.text_effect_textpatheffect;

export const WATERMARK_HISTORY_KEY = 'change-watermark-action';
